import React, { useEffect, useRef } from 'react';
import { Box, Grid, Paper } from '@material-ui/core';
import { Form } from '@unform/web';
import { toast } from 'react-toastify';
import { useHistory, useParams } from 'react-router-dom';
import { GetPatient, formatCPF, formatPhone } from '@bforms-web/common';
import { PATIENTS_ROUTE } from '../../../constants';
import { useLoading } from '../../../contexts/loading.context';
import Button from '../../Button';
import Input from '../../Input';
import PageTitle from '../../PageTitle';
import { useStyles } from './styles';

export type GetPatientProps = {
  getPatient: GetPatient;
};

export default function PatientView({ getPatient }: GetPatientProps): JSX.Element {
  const classes = useStyles();
  const formRef = useRef({} as any);
  const { showLoading, hideLoading } = useLoading();
  const { push } = useHistory();
  const { id } = useParams<{ id: string }>();

  const handleSubmit = () => {
    push(PATIENTS_ROUTE);
  }

  useEffect(() => {
    if (!id) return;
    showLoading();
    async function runAsync() {
      try {
        const patient = await getPatient.execute(id);
        let newPatient: any = patient;

        newPatient.cpf = formatCPF(newPatient.cpf);
        newPatient.cellPhone = newPatient.cellPhone ? formatPhone(newPatient.cellPhone) : '';
        newPatient.homePhone = newPatient.homePhone ? formatPhone(newPatient.homePhone) : '';
        newPatient.additionalPhone = newPatient.additionalPhone ? formatPhone(newPatient.additionalPhone) : '';
                
        if (patient.birthDate) {
          const date = new Date(patient.birthDate);
          const day = String(date.getUTCDate()).padStart(2, '0');
          const month = String(date.getUTCMonth() + 1).padStart(2, '0');
          const year = date.getUTCFullYear();
          newPatient.formattedDate = `${day}/${month}/${year}`;
        }

        formRef.current.setData(newPatient);
      } catch (err) {
        console.log(err);
        toast.error('Falha ao carregar paciente');
        push(PATIENTS_ROUTE);
      } finally {
        hideLoading();
      }
    }
    runAsync();
  },
  [id],
);

  return (
    <Box className={classes.container}>
      <PageTitle>{'Dados do paciente'}</PageTitle>
      <br />
      <Form ref={formRef} onSubmit={handleSubmit}>
        <Paper className={classes.container}>
          <Grid container spacing={2} direction="column">
            <Grid item xs={12} sm="auto">
              <Input
                name="name"
                variant="outlined"
                label={'Nome'}
                className={classes.input}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm="auto">
              <Input
                name="email"
                variant="outlined"
                label={'Email'}
                className={classes.input}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm="auto">
              <Input
                name="cpf"
                variant="outlined"
                label={'CPF'}
                className={classes.input}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm="auto">
              <Input
                name="gender"
                variant="outlined"
                label={'Genero'}
                className={classes.input}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm="auto">
              <Input
                name="formattedDate"
                variant="outlined"
                label={'Idade'}
                className={classes.input}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm="auto">
              <Input
                name="cellPhone"
                variant="outlined"
                label={'Celular'}
                className={classes.input}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm="auto">
              <Input
                name="homePhone"
                variant="outlined"
                label={'Telefone Residencial'}
                className={classes.input}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} sm="auto">
              <Input
                name="additionalPhone"
                variant="outlined"
                label={'Telefone Adicional'}
                className={classes.input}
                disabled={true}
              />
            </Grid>
            <Grid item>
              <Button type="submit" variant="contained" color="primary">
                {'Voltar'}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Form>
    </Box>
  );
}
